import React from "react";
import { Eye, Pencil, Trash2 } from "lucide-react";

export default function PayrollProcessingTable({
  payrolls,
  onEdit,
  onDelete,
}) {
  return (
    <div className="finance-table-container">
      <table className="finance-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Employee ID</th>
            <th>Employee Name</th>
            <th>Salary Structure</th>
            <th>Gross Salary</th>
            <th>Deductions</th>
            <th>Net Salary</th>
            <th>Month</th>
            <th>Year</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {payrolls.length > 0 ? (
            payrolls.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>

                <td>{item.employeeId}</td>

                <td>{item.employeeName}</td>

                <td>{item.salaryStructure}</td>

                <td>₹ {Number(item.grossSalary).toLocaleString("en-IN")}</td>

                <td>₹ {Number(item.deductions).toLocaleString("en-IN")}</td>

                <td>
                  <strong>
                    ₹ {Number(item.netSalary).toLocaleString("en-IN")}
                  </strong>
                </td>

                <td>{item.month}</td>

                <td>{item.year}</td>

                <td>
                  <span
                    className={`status-badge ${
                      item.status === "Processed"
                        ? "status-active"
                        : item.status === "Pending"
                        ? "status-pending"
                        : "status-inactive"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>

                <td className="finance-action-cell">
                  <button
                    className="finance-icon-btn"
                    title="View"
                  >
                    <Eye size={18} />
                  </button>

                  <button
                    className="finance-icon-btn"
                    title="Edit"
                    onClick={() => onEdit(item)}
                  >
                    <Pencil size={18} />
                  </button>

                  <button
                    className="finance-icon-btn delete"
                    title="Delete"
                    onClick={() => onDelete(item.id)}
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" style={{ textAlign: "center" }}>
                No payroll records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}